import { createHook, createStore, createActionsHook } from 'react-sweet-state';
import {
	resetPayload,
	setPayload,
	addScrollElement,
	removeScrollElement,
	setOffset,
	setOffsetFallback,
} from './actions';
import { DEFAULT_PAYLOAD } from './constants';
import type { State, Payload } from './types';

const initialState: State = {};

const store = createStore({
	name: 'horizontal-scrolling-synced',
	actions: {
		resetPayload,
		setPayload,
		addScrollElement,
		removeScrollElement,
		setOffset,
		setOffsetFallback,
	},
	initialState,
});

export const usePayload = createHook(store, {
	selector: (state: State, name: string): Payload => state[name] ?? DEFAULT_PAYLOAD,
});

export const useOffset = createHook(store, {
	selector: (state: State, name: string): number => state[name]?.offset ?? 0,
});

export const useActions = createActionsHook(store);
